import fontawesome from '@fortawesome/fontawesome';
import {
  faBook,
  faCheck,
  faArrowLeft,
  faArrowRight,
  faEdit,
  faFile,
  faWrench,
  faSpinner,
  faTimes,
  faFilePlus,
  faSave,
  faFolderOpen,
  faSync,
  faQuestionCircle,
  faThumbtack,
  faSpinnerThird,
  faTrash,
} from '@whitebox-learning/fontawesome-pro-light-svg-icons';

fontawesome.library.add(
  faBook,
  faCheck,
  faArrowLeft,
  faArrowRight,
  faEdit,
  faFile,
  faWrench,
  faSpinner,
  faTimes,
  faFilePlus,
  faSave,
  faFolderOpen,
  faSync,
  faQuestionCircle,
  faThumbtack,
  faSpinnerThird,
  faTrash
);
